import { useState } from 'react'
import EndIcon from '@mui/icons-material/Event'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { func, any, string, bool } from 'prop-types'

export const CvsDatePicker = ({
  value = new Date(),
  handleChange = _value => {},
  label = '',
  margin = 'normal',
  color = 'primary',
  format = 'YYYY-MM-DD',
  disabled = false,
  shouldDisableDate = _value => {},
  shrinkLabel = false,
  style = {},
}) => {
  const [open, setOpen] = useState(false)

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        disabled={disabled}
        shouldDisableDate={shouldDisableDate}
        style={style}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        placeholder={format}
        label={label}
        margin={margin}
        color={color}
        inputFormat={format}
        onChange={handleChange}
        value={value}
        renderInput={(props, inputValue) => {
          return (
            <TextField
              disabled={disabled}
              onClick={() => setOpen(true)}
              variant="outlined"
              value={inputValue}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <EndIcon />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                ...(shrinkLabel && { shrink: shrinkLabel }),
              }}
              {...props}
            />
          )
        }}
      />
    </LocalizationProvider>
  )
}

CvsDatePicker.propTypes = {
  handleChange: func,
  value: any,
  label: string,
  margin: string,
  color: string,
  format: string,
  disabled: bool,
  shouldDisableDate: func,
  shrinkLabel: bool,
  style: any,
}
